import React, { useEffect, useState } from "react";
import { useTheme } from "@mui/material/styles";

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import Container from "@mui/material/Container";
import TableContainer from "@mui/material/TableContainer";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CommonTableHeaders from "./TableHeaders/CommonTableHeaders";
import CurrnetPlayersTableBody from "./TableBodys/CurrentPlayersTableBody";

interface GameInfo {
  id: string;
  currentPlayers: { [key: string]: any };
  playerlist: { [key: string]: any };
  [key: string]: any;
}

interface CurrentPlayersTableProps {
  gameInfo: GameInfo;
  setModalDets: (dets: any) => void;
}

const CurrentPlayersTable: React.FC<CurrentPlayersTableProps> = (props) => {
  const theme = useTheme();
  const { gameInfo } = props;
  const { currentPlayers, playerlist } = gameInfo;

  // Check if there are any players that are both in currentPlayers AND playerlist
  const hasActivePlayers = Object.keys(currentPlayers).some(playerId => 
    currentPlayers[playerId] && playerlist[playerId]
  );

  // Hide table completely if no active players
  if (!hasActivePlayers) {
    return (
      <Box sx={{ textAlign: "center", py: 4 }}>
        <Typography variant="body1" color="text.secondary">
          Nobody currently playing
        </Typography>
      </Box>
    );
  }
  
  if (gameInfo) {
    return (
      <Container>
        <TableContainer
          component={Paper}
          sx={{
            ...theme.table?.defaultContainer,
            textAlign: "center",
            margin: "auto",
            padding: "auto",
            borderRadius: "20px",
          }}
          elevation={5}
        >
          <Table>
            <CommonTableHeaders />
            <CurrnetPlayersTableBody {...props} />
          </Table>
        </TableContainer>
      </Container>
    );
  }
  return (
    <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
      <CircularProgress />
    </Box>
  );
};

export default CurrentPlayersTable;
